import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowRight, Facebook, Instagram, LogIn } from 'lucide-react';

export default function Footer() {
  return (
    <footer id="contact">
      <div className="bg-[#0D5BD7] text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-11 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="flex items-center gap-5">
            <div className="w-14 h-14 rounded-xl border-2 border-white/90 flex items-center justify-center shrink-0">
              <Phone className="w-5 h-5" />
            </div>
            <div>
              <div className="text-[11px] tracking-[0.24em] font-semibold text-white/90">CALL US</div>
              <div className="mt-1 text-[26px] font-extrabold tracking-wide leading-none">343.558.8820</div>
            </div>
          </div>

          <div className="flex items-center gap-5 lg:justify-center">
            <div className="w-14 h-14 rounded-xl border-2 border-white/90 flex items-center justify-center shrink-0">
              <Mail className="w-5 h-5" />
            </div>
            <div>
              <div className="text-[11px] tracking-[0.24em] font-semibold text-white/90">EMAIL US</div>
              <div className="mt-1 text-[18px] font-semibold">Info@aplusautoglass.ca</div>
            </div>
          </div>

          <div id="locations" className="flex items-center gap-5 lg:justify-end">
            <div className="w-14 h-14 rounded-xl border-2 border-white/90 flex items-center justify-center shrink-0">
              <MapPin className="w-5 h-5" />
            </div>
            <div>
              <div className="text-[11px] tracking-[0.24em] font-semibold text-white/90">LOCATIONS</div>
              <Link to="/locations" className="mt-2 inline-flex items-center gap-2 border border-white/80 px-4 py-1.5 rounded-full text-[11px] font-bold tracking-[0.18em] hover:bg-white hover:text-[#0D5BD7] transition-colors">
                VIEW LOCATIONS <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#0a1220] text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-xs text-white/60">© 2026 A+ Auto Glass. All rights reserved.</div>
          <div className="flex items-center gap-3">
            <a
              href="https://glassflow.ca/portal/a-auto-glass--sipm"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="dealer-login-btn"
              className="inline-flex items-center gap-2 h-9 px-4 rounded-full border border-white/30 hover:border-white hover:bg-white hover:text-[#0a1220] text-white text-[10.5px] font-bold tracking-[0.2em] transition-colors"
            >
              <LogIn className="w-3.5 h-3.5" /> DEALER LOGIN
            </a>
            <a href="https://www.facebook.com/profile.php?id=100090557553388" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" aria-label="Instagram" className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
